import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import { Navigate } from 'react-router-dom';

const homeRedirectPage = PageBlueprint.make({
  params: {
    path: '/',
    loader: async () => <Navigate to="/catalog" />,
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [homeRedirectPage],
});
